import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ToggleSimple from '../elements/ToggleSimple'
import DataSource from '../DataSource'
import globals from '../globals'
import ReactModal from '../modules/ReactModal'
import Button from '../elements/Button'
import LoadingOverlay from '../components/LoadingOverlay'

const MasterSwitchForm = (props) => {
    const [isEnabled, setIsEnabled] = useState(props.isEnabled)
    const [isLoading, setIsLoading] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const handleChange = (event, value) => {
        event.preventDefault()
        setIsLoading(true)
        setShowModal(false)
        setIsEnabled(value)
        setHasError(false)
        DataSource.postData(props.postUrl, {
            isEnabled: value,
            serviceId: props.serviceId
        }, response => {
            // todo: Might be nice to show the user a success tick or similar
            setIsLoading(false)
            if (props.handleChange) {
                props.handleChange(value)
            }
        }, response => {
            setHasError(true)
            setIsLoading(false)
            globals.handleError(response.message, response)
            setIsEnabled(!value)
        })
    }

    const handleCancel = (event) => {
        event.preventDefault()
        setShowModal(false)
    }

    return (
        <React.Fragment>
            <div className='d-inline-block mb-2' style={{ maxWidth: '250px' }}>
                <LoadingOverlay isLoading={isLoading}>
                    <ToggleSimple value={isEnabled} handleChange={() => setShowModal(true)} />
                    <h4 className='bold text-uppercase m-0 my-2' dangerouslySetInnerHTML={{ __html: globals.noWidows(props.title) }} />
                </LoadingOverlay>
                <div className='text-center mt-2'>
                    {hasError ? <div className='row-error mb-2'>Oops! Something went wrong. Please try again to see if the issue persists.</div> : ''}
                    <p className='m-0 font-small lh' dangerouslySetInnerHTML={{ __html: globals.noWidows(props.subTitle) }} />
                </div>
            </div>
            <ReactModal showModal={showModal} handleCloseModal={() => setShowModal(false)} heading='Just checking'>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <p className='mt-0 mb-4 lh'>Please confirm you would like to <span className='bold'>{isEnabled ? 'disable' : 'enable'}</span> {props.type}?</p>
                        <div className='d-flex justify-content-center'>
                            <Button title='Confirm' action={event => handleChange(event, !isEnabled)} className='mr-3' />
                            <Button title='Cancel' action={event => handleCancel(event)} color='red' />
                        </div>
                    </div>
                    {props.children}
                </div>
            </ReactModal>
        </React.Fragment>
    )
}

MasterSwitchForm.propTypes = {
    serviceId: PropTypes.number.isRequired,
    isEnabled: PropTypes.bool.isRequired,
    postUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    handleChange: PropTypes.func
}

MasterSwitchForm.defaultProps = {
    isEnabled: false
}

export default MasterSwitchForm



// WEBPACK FOOTER //
// ./resources/js/forms/MasterSwitchForm.js